module.exports = __webpack_public_path__ + "media/images/customer_code_sample-b4a5a2cb7838867505282ae5686f1272.png";